"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSnowparkLabSignup = exports.SNOWPARK_PYTHON_LAB = exports.vaildateName = exports.vaildateIdentifier = exports.isEmailValid = exports.validateSnowflakeEmail = exports.SignupEventType = exports.invalidCharactersRegex = exports.urlRegex = exports.OidcProvider = exports.OriginPage = exports.PostAccountCreationError = void 0;
exports.isFreemailEmailDomain = isFreemailEmailDomain;
exports.isSuppressionErrorCode = isSuppressionErrorCode;
const error_1 = require("./error");
__exportStar(require("./countries"), exports);
__exportStar(require("./roles"), exports);
__exportStar(require("./error"), exports);
__exportStar(require("./featureFlags"), exports);
__exportStar(require("./awsMarketplace"), exports);
__exportStar(require("./deploymentMetadata"), exports);
__exportStar(require("./cloud"), exports);
__exportStar(require("./utils/inputValidation"), exports);
__exportStar(require("./experiments"), exports);
__exportStar(require("./signupFlows"), exports);
__exportStar(require("./oidcSupport"), exports);
__exportStar(require("./urlParams"), exports);
__exportStar(require("./oidcCarriedFields"), exports);
var PostAccountCreationError;
(function (PostAccountCreationError) {
    PostAccountCreationError["SET_ALIAS_NAME_ERROR"] = "SET_ALIAS_NAME_ERROR";
    PostAccountCreationError["ALIAS_GLOBAL_SYNC_ERROR"] = "ALIAS_GLOBAL_SYNC_ERROR";
    PostAccountCreationError["FIND_ALIAS_ERROR"] = "FIND_ALIAS_ERROR";
    PostAccountCreationError["GENERIC_ALIAS_ERROR"] = "GENERIC_ALIAS_ERROR";
})(PostAccountCreationError || (exports.PostAccountCreationError = PostAccountCreationError = {}));
// allow api to identify where the call is coming from
var OriginPage;
(function (OriginPage) {
    OriginPage["APP"] = "app";
})(OriginPage || (exports.OriginPage = OriginPage = {}));
// OIDC Signup Types
var OidcProvider;
(function (OidcProvider) {
    OidcProvider["GOOGLE"] = "GOOGLE";
    OidcProvider["MICROSOFT"] = "MICROSOFT";
})(OidcProvider || (exports.OidcProvider = OidcProvider = {}));
exports.urlRegex = /(http[s]?:\/\/)?[^\s(["<,>]*\.[^\s[",><]*/im;
exports.invalidCharactersRegex = /[<>;{}\(\)\/~]/;
var SignupEventType;
(function (SignupEventType) {
    SignupEventType["UI_CLICK"] = "ui_click";
    SignupEventType["UI_ERROR"] = "ui_error";
    SignupEventType["UI_PERFORMANCE"] = "ui_performance";
    SignupEventType["UI_RESPONSE_ERROR"] = "ui_response_error";
    SignupEventType["UI_RESPONSE_SUCCESS"] = "ui_response_success";
})(SignupEventType || (exports.SignupEventType = SignupEventType = {}));
// As far as we can tell, this matches Salesforce validation: https://developer.salesforce.com/docs/atlas.en-us.noversion.mc-apis.meta/mc-apis/using_regular_expressions_to_validate_email_addresses.htm
const validateEmailFormat = /^[a-z0-9!#$%&'*/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+(?!localdomain)[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
// Allow `+` in the email if domain is `snowflake.com`
exports.validateSnowflakeEmail = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@snowflake.com$/i;
const isEmailValid = (value) => {
    return exports.validateSnowflakeEmail.test(value) || validateEmailFormat.test(value);
};
exports.isEmailValid = isEmailValid;
const vaildateIdentifier = (value, customError) => {
    /*
      Snowflake Identifier must:
      - Start with a letter (A-Z, a-z) or an underscore (“_”).
      - Contain only letters, underscores, decimal digits (0-9), and dollar signs (“$”).
      https://docs.snowflake.com/en/sql-reference/identifiers-syntax.html
      The following function validates that this requirement is met.
     */
    const validIdentifier = /^[A-Za-z_][A-Za-z0-9$_]*$/;
    if (validIdentifier.test(value)) {
        return true;
    }
    if (customError) {
        return customError;
    }
    return 'Name contains invalid characters';
};
exports.vaildateIdentifier = vaildateIdentifier;
const vaildateName = (value, customError) => {
    const validAsciiChars = /^[\x20\x21\x23-\x7F]*$/;
    if (validAsciiChars.test(value)) {
        return true;
    }
    if (customError) {
        return customError;
    }
    return 'Name contains invalid characters';
};
exports.vaildateName = vaildateName;
function isFreemailEmailDomain(email) {
    const freemailDomains = ['gmail.com', 'yahoo.com', 'outlook.com', 'hotmail.com', 'yahoo.co.in'];
    const [, domain] = email.split('@');
    return freemailDomains.includes(domain);
}
function isSuppressionErrorCode(errorCode) {
    return (errorCode == error_1.SignupApiErrorCode.SUPPRESSED_EMAIL ||
        errorCode == error_1.SignupApiErrorCode.SUPPRESSED_COUNTRY ||
        errorCode == error_1.SignupApiErrorCode.SUPPRESSED_GENERIC);
}
exports.SNOWPARK_PYTHON_LAB = 'getStartedWithSnowparkInPythonWorksheets';
const isSnowparkLabSignup = (lab) => {
    if (!lab) {
        return false;
    }
    if (lab === exports.SNOWPARK_PYTHON_LAB) {
        return true;
    }
    return false;
};
exports.isSnowparkLabSignup = isSnowparkLabSignup;
//# sourceMappingURL=index.js.map